import React, { useEffect, useState } from "react";
import ActionableCustomerList from "../actionable_list/ActionableCustomerList";
import CardTabs from "modules/common/card-tabs/CardTabs";
import Engagement from "pages/Engagement";
import ConsultCallBookings from "./ConsultCallBookings";
import OpenOrders from "./OpenOrders";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { Tabs, Tab } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Actionables = ({
  tempEngData,
  todayEngData,
  tempLoading,
  todayLoading,
}) => {
  const [activeSubTab, setActiveSubTabs] = useState("temporary");
  const [page, newPage] = useState(1);
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [todayPage, setTodayPage] = useState(1);
  const [todayFilter, setTodayFilter] = useState([]);
  const [todayPageCount, setTodayPageCount] = useState(1);
  const [showCustomerInFull, setShowCustomerInFull] = useState(false);
  const [filterBy, setFilterBy] = useState([]);
  const [sortedData, setSortedData]= useState([]);
  const [todaySortedData, setTodaySortedData]=useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const subTab = searchParams.get("subTab");

  useEffect(()=>{
    setSortedData(tempEngData);
  },[])

  useEffect(()=>{
    setTodaySortedData(todayEngData);
  },[])

  useEffect(() => {
    setActiveSubTabs(subTab);
    navigate(`/dashboard?tab=actionable&subTab=${subTab}`);
  }, [subTab]);

  const handleTabChange = (tabKey) => {
    setActiveSubTabs(tabKey);
    navigate(`/dashboard?tab=actionable&subTab=${tabKey}`);
  };



  useEffect(() => {
    async function calculate() {
      const numOfSubarrays = Math.max(
        Math.ceil((sortedData?.length || 0) / 10),
        0
      );
      const arrayOfArrays = sortedData
        ? Array.from({ length: numOfSubarrays }, (_, i) => {
            const start = i * 10;
            const end = start + 10;
            return sortedData?.slice(start, end);
          })
        : [];
      setPageCount(Math.min(Math.ceil((sortedData?.length || 0) / 10), 100));
      setFilter(arrayOfArrays[page - 1] || []);
    }
    calculate();
  }, [sortedData, page]);


  useEffect(() => {
    async function calculate() {
      const numOfSubarrays = Math.max(
        Math.ceil((todaySortedData?.length || 0) / 10),
        0
      );
      const arrayOfArrays = todaySortedData
        ? Array.from({ length: numOfSubarrays }, (_, i) => {
            const start = i * 10;
            const end = start + 10;
            return todaySortedData?.slice(start, end);
          })
        : [];
      setTodayPageCount(
        Math.min(Math.ceil((todaySortedData?.length || 0) / 10), 100)
      );
      setTodayFilter(arrayOfArrays[todayPage - 1] || []);
    }
    calculate();
  }, [todaySortedData, todayPage]);

  useEffect(()=>{
    setFilterBy([])
  },[subTab])

  useEffect(() => {
    if (subTab ==="temporary") {
      if(filterBy?.length){
        setSortedData(
        [...tempEngData?.filter((item) => {
          return filterBy.includes("slot_booking_total") ? item?.is_slot_booked || ["SLOT_BOOKING"].includes(item?.tag) : filterBy.includes(item?.tag)
        })])
        newPage(1);
      }
      else{
        setSortedData([...tempEngData]);
        newPage(1);
      }
    } else if(subTab==="today"){
      if(filterBy.length){
        const data=todayEngData?.filter((item) => {
          return filterBy.includes("slot_booking_total") ? item?.is_slot_booked || ["SLOT_BOOKING"].includes(item?.tag) : filterBy.includes(item?.tag)
        })
        setTodaySortedData(data);
        newPage(1);
      }
      else{
        setTodaySortedData([...todayEngData]);
        newPage(1);
      }
    }
  }, [filterBy, tempEngData, todayEngData]);

  return (
    <>
      <Tabs
        id="controlled-tab-example"
        activeKey={activeSubTab}
        onSelect={handleTabChange}
        className="bg-white rounded-top pt-2 shadow"
      >
        <Tab
          eventKey="temporary"
          title="Temporary"
          className="bg-white rounded-bottom pt-2 shadow"
        >
          <>
            <ActionableCustomerList
              actionableTabs={"temporary"}
              actionableData={filterData}
              actionableLoading={tempLoading}
              showCustomerInFull={showCustomerInFull}
              setShowCustomerInFull={setShowCustomerInFull}
              filterBy={filterBy}
              setFilterBy={setFilterBy}
            />
            {!showCustomerInFull ? (
              <div className="mt-n5" style={{ width: "30%" }}>
                <PaginationDiv
                  newPage={newPage}
                  paginationData={{ pageCount: pageCount || 1, page: page }}
                />
              </div>
            ) : null}
          </>
        </Tab>
        <Tab
          eventKey="today"
          title="Today"
          className=" bg-white rounded-bottom pt-2"
        >
          <>
            <ActionableCustomerList
              actionableTabs={"today"}
              actionableData={todayFilter}
              actionableLoading={todayLoading}
              showCustomerInFull={showCustomerInFull}
              setShowCustomerInFull={setShowCustomerInFull}
              filterBy={filterBy}
              setFilterBy={setFilterBy}
            />
            {!showCustomerInFull ? (
              <div className="" style={{ width: "30%" }}>
                <PaginationDiv
                  newPage={setTodayPage}
                  paginationData={{
                    pageCount: todayPageCount || 1,
                    page: todayPage,
                  }}
                />
              </div>
            ) : null}
          </>
        </Tab>
        <Tab
          eventKey="engagement"
          title="Engagement"
          className=" bg-white rounded-bottom shadow p-2 pt-3"
        >
          <Engagement subTab={subTab} />
        </Tab>
        <Tab
          eventKey="consultCall"
          title="Consult Call Booking"
          className=" bg-white p-2"
        >
          <ConsultCallBookings subTab={subTab}/>
        </Tab>
        <Tab
          eventKey="openOrder"
          title="Open Orders"
          className=" bg-white rounded-bottom p-2"
        >
          <OpenOrders subTab={subTab} />
        </Tab>
      </Tabs>
    </>
  );
};

export default Actionables;

